import { Theme } from '@simplybenefits/sb-ui-library';

const colors = Theme.colors;
const globalStyles = Theme.globalStyles;

export { colors, globalStyles };